import { useState, useEffect } from "react";
import AdModal from "./AdModal";
import AdCard from "./AdCard";
import axios from "axios";
import { useLanguage } from "../../contexts/LanguageContext";

export default function AdManagement() {
  const [ads, setAds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentAd, setCurrentAd] = useState(null);
  const { t } = useLanguage();

  useEffect(() => {
    // Fetch ads from the database
    axios.get("http://localhost:5000/ads")
      .then((response) => setAds(response.data))
      .catch((error) => console.error("Error fetching ads:", error));
  }, []);

  const openAddAdModal = () => {
    setCurrentAd(null);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const addAd = (title, description) => {
    axios.post("http://localhost:5000/ads", { title, description })
      .then((response) => {
        const newAd = { ad_id: response.data.adId, title, description };
        setAds([...ads, newAd]);
        closeModal();
      })
      .catch((error) => console.error("Error adding ad:", error));
  };

  const removeAd = (adId) => {
    if (window.confirm(t("confirmRemoveAd"))) {
      axios.delete(`http://localhost:5000/ads/${adId}`)
        .then(() => {
          setAds(ads.filter((ad) => ad.ad_id !== adId));
        })
        .catch((error) => console.error("Error removing ad:", error));
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '1.4rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>{t('manageAdvertisements')}</h1>
        <button onClick={openAddAdModal} style={{
          padding: '10px 20px', borderRadius: '12px', border: 'none', cursor: 'pointer',
          background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff',
          fontWeight: 600, fontSize: '0.85rem', transition: 'opacity 0.2s',
        }}
          onMouseEnter={e => e.target.style.opacity = '0.85'}
          onMouseLeave={e => e.target.style.opacity = '1'}
        >{t('addNewAdvertisement')}</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {ads.map((ad) => (
          <AdCard key={ad.ad_id} ad={ad} onRemove={removeAd} />
        ))}
      </div>

      {isModalOpen && <AdModal ad={currentAd} onClose={closeModal} onSubmit={addAd} />}
    </>
  );
}

